<div style="display: flex; align-items:center">
    <div  class="icon--win-loss" style="display: inline;" *ngIf="onRight" [ngClass]="{ win: winLoss === true, loss: winLoss === false }">
        {{ winLoss === true ? "WIN" : "LOSS" }}
      </div>
  <div  style="margin-left:15px" class="uppertext-black match-count">
    {{ selfPoints }} - {{ otherPoints }}
  </div>
  <div  class="icon--win-loss" style="" *ngIf="onRight === false" [ngClass]="{ win: winLoss === true, loss: winLoss === false }">
    {{ winLoss === true ? "WIN" : "LOSS" }}
  </div>
</div>
